import { ChangeDetectorRef, Component, ComponentFactoryResolver, HostBinding, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, ViewChild } from '@angular/core';
import { MatrixDefInfoEntity } from './entitis/matrix-def-info.entity';
import { MatrixDataInfoEntity } from './entitis/matrix-data-info.entity';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable, of } from 'rxjs';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { LookupGridComponent, PickedResult, ServerSideToken } from '@farris/ui-lookup';
import { BsModalService } from '@farris/ui-modal';
import { EnumListComponent } from './enum-list/enum-list.component';
import { MatrixFieldInfoEntity } from './entitis/matrix-field-info.entity';
import { PerformerEntity } from '../../entities/performer.entity';
import { MatrixDefHelpService } from './service/matrix-performer.component.service';
import { LookupDataService } from '@farris/lookup-config';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

@Component({
  selector: 'app-matrix-performer',
  templateUrl: './matrix-performer.component.html',
  styleUrls: ['./matrix-performer.component.scss'],
  providers: [
    { provide: ServerSideToken, useClass: LookupDataService },
     WfLocalePipe,
  ]
})
export class MatrixPerformerComponent implements OnInit {
  @HostBinding('class')
  cls = 'd-flex flex-fill h-100';
  display: string = 'none';
  typeReadOnly = false;
  items: MatrixDefInfoEntity[] = [];
  pageIndex = 1;
  pageSize = 20;
  pageList = [10, 20, 30, 50, 100];
  total = 0;
  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';

  // 帮助相关
  index: number;
  fieldId = '';
  value: any;
  helpId;
  dataUri: string;
  /**
   * 矩阵定义显示列
   */
  columns = [
    { title: this.localePipe.transform('component.matrixPerformer.code'), field: 'code', width: 100 },
    { title: this.localePipe.transform('component.matrixPerformer.name'), field: 'name', width: 100 }
  ];
  users: PerformerEntity[] = [];

  dataFieldAndValues = []; // { text: '部门', value: 'department' },
  curDataFieldValue = '';

  matrixDefEntityList: MatrixDefInfoEntity[] = [];
  curMatrixDefEntity: MatrixDefInfoEntity = new MatrixDefInfoEntity();
  curMatrixDataEntity: MatrixDataInfoEntity = new MatrixDataInfoEntity();

  conditionFields: MatrixFieldInfoEntity[] = [];
  exprGroup = [
    { name: this.localePipe.transform('component.matrixPerformer.help'), value: 'help' }
  ];
  mulGroup = [
    { name: this.localePipe.transform('component.matrixPerformer.multivalue'), value: 'Multivalue' }
  ];
  /**
   * 条件字段是否启用表达式
   */
  condition1: string;
  condition1ExprAble = true;
  condition2: string;
  condition2ExprAble = true;
  condition3: string;
  condition3ExprAble = true;
  /**
   * 条件字段是否启用多值
   */
  MultivalueOption1: string;
  condition1Multivalue = false;
  MultivalueOption2: string;
  condition2Multivalue = false;
  MultivalueOption3: string;
  condition3Multivalue = false;
  /**
   * 编辑器页面显示文字，防范浅拷贝问题（对于条件字段的值和显示文字都不要在当前实体中进行修改只有点击确定时，才将其保存至当前实体并返回）
   */
  condition1Text = '';
  condition1Value = '';
  condition2Text = '';
  condition2Value = '';
  condition3Text = '';
  condition3Value = '';

  @Input()
  set setMatrixDataEntity(dataEntity: MatrixDataInfoEntity) {
    this.curMatrixDataEntity = dataEntity;
    const url = '/api/runtime/wf/v1.0/matrixDefinition/' + dataEntity.matrixDefId;
    this.http.get(url).subscribe((re: any) => {
      this.curMatrixDefEntity = re;
      this.setFields();
      this.curDataFieldValue = dataEntity.dataFieldAlias;
    })
    if (dataEntity.matrixDefId) {
      this.typeReadOnly = true;
    }

    if (!this.curMatrixDataEntity.conditionField1) {
      this.condition1 = 'expr';
      this.condition1ExprAble = true;
    } else if (this.curMatrixDataEntity.conditionField1.charAt(0) === '{') {
      this.condition1 = 'expr';
      this.condition1ExprAble = true;
    } else {
      this.condition1 = 'help';
      this.condition1ExprAble = false;
    }

    if (!this.curMatrixDataEntity.conditionField2) {
      this.condition2 = 'expr';
      this.condition2ExprAble = true;
    } else if (this.curMatrixDataEntity.conditionField2.charAt(0) === '{') {
      this.condition2 = 'expr';
      this.condition2ExprAble = true;
    } else {
      this.condition2 = 'help';
      this.condition2ExprAble = false;
    }

    if (!this.curMatrixDataEntity.conditionField3) {
      this.condition3 = 'expr';
      this.condition3ExprAble = true;
    } else if (this.curMatrixDataEntity.conditionField3.charAt(0) === '{') {
      this.condition3 = 'expr';
      this.condition3ExprAble = true;
    } else {
      this.condition3 = 'help';
      this.condition3ExprAble = false;
    }

    if (this.curMatrixDataEntity.multivaluedCondition === 'condition1') {
      this.MultivalueOption1 = 'Multivalue';
      this.condition1Multivalue = true;
    } else if (this.curMatrixDataEntity.multivaluedCondition === 'condition2') {
      this.MultivalueOption2 = 'Multivalue';
      this.condition2Multivalue = true;
    } else if (this.curMatrixDataEntity.multivaluedCondition === 'condition3') {
      this.MultivalueOption3 = 'Multivalue';
      this.condition3Multivalue = true;
    }

    this.condition1Text = this.curMatrixDataEntity.conditionFieldText1 ? this.curMatrixDataEntity.conditionFieldText1 : '';
    this.condition1Value = this.curMatrixDataEntity.conditionField1 ? this.curMatrixDataEntity.conditionField1 : '';
    this.condition2Text = this.curMatrixDataEntity.conditionFieldText2 ? this.curMatrixDataEntity.conditionFieldText2 : '';
    this.condition2Value = this.curMatrixDataEntity.conditionField2 ? this.curMatrixDataEntity.conditionField2 : '';
    this.condition3Text = this.curMatrixDataEntity.conditionFieldText3 ? this.curMatrixDataEntity.conditionFieldText3 : '';
    this.condition3Value = this.curMatrixDataEntity.conditionField3 ? this.curMatrixDataEntity.conditionField3 : '';
  }


  @ViewChild('lookup') public lookUp: LookupGridComponent;

  constructor(
    private http: HttpService,
    public designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private modalService: BsModalService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private matDefService: MatrixDefHelpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    // this.getMatrixLineType();
  }

  ngOnInit() {
    let rootPath = '';
    try {
      rootPath = (window as any).gspframeworkService.common.getBasePath.get();
    } catch (error) {
    }
    this.dataUri = rootPath + '/api/runtime/wf/v1.0/matrixDefinition/getMatrixDef';
  }

  /**
   * 获取矩阵定义
   */
  getMatrixLineType() {
    const url = '/api/runtime/wf/v1.0/matrixDefinition';
    this.http.get(url).subscribe((re: any) => {
      this.matrixDefEntityList = re;
      this.items = this.matrixDefEntityList.slice(0, this.pageSize);
      this.total = this.matrixDefEntityList.length;
    });
  }

  private setFields() {
    this.conditionFields = [];
    this.dataFieldAndValues = [];
    // 先对条件字段按照排序号进行排序
    this.curMatrixDefEntity.conditionField.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });
    // 将排序后的条件放入条件字段数组中
    for (const condition of this.curMatrixDefEntity.conditionField) {
      this.conditionFields.push(condition);
    }
    // 先对数据字段按照排序号进行排序
    this.curMatrixDefEntity.dataField.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });
    // 填充数据字段的下拉列表
    for (const data of this.curMatrixDefEntity.dataField) {
      const temp = {
        text: data.alias,
        value: data.alias
      };
      this.dataFieldAndValues.push(temp);
    }
  }

  dictPicked = (rowData) => { // 选完矩阵定义后执行
    // 先将当前绑定的数据清空
    this.curMatrixDataEntity = new MatrixDataInfoEntity();
    this.curDataFieldValue = '';
    this.curMatrixDefEntity = rowData;
    this.curMatrixDataEntity.matrixDefId = rowData.id;
    this.curMatrixDataEntity.matrixDefName = rowData.name;
    this.setFields();
    return of(true);
  }

  onClear() {
    this.curMatrixDataEntity = new MatrixDataInfoEntity();
  }

  /**
   * 编辑条件
   */
  editCondition() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.curMatrixDataEntity.condition); // this.reportingLineDataEntity.condition
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.curMatrixDataEntity.condition = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  onHelpSearch(data, index, id) { // 打开帮助
    this.index = index;
    this.fieldId = id;
    this.helpId = this.curMatrixDefEntity.conditionField[this.index].smartHelp;
    this.lookUp.onClear();
    this.lookUp.showDialog();
  }

  openEnumValue(index, id) {
    this.index = index;
    this.fieldId = id;
    this.showEnumList(JSON.parse(this.curMatrixDefEntity.conditionField[this.index].enumList));
  }

  private showEnumList(enumList: any[]) {
    const compFactory = this.resolver.resolveComponentFactory(EnumListComponent);
    const compRef = compFactory.create(this.injector);
    const modalConfig = {
      title: this.localePipe.transform('component.matrixPerformer.enumSelection'),
      width: 650,
      height: 450,
      showButtons: true,
      buttons: compRef.instance.btnRef,
    };
    if (enumList && enumList.length > 0) {
      compRef.instance.load(enumList);
    }
    compRef.instance.confirm.subscribe((re: any[]) => { // 点击确定
      if (this.index === 0) {
        this.condition1Text = re[0].value;
        this.condition1Value = re[0].value;
      } else if (this.index === 1) {
        this.condition2Text = re[0].value;
        this.condition2Value = re[0].value;
      } else if (this.index === 2) {
        this.condition3Text = re[0].value;
        this.condition3Value = re[0].value;
      }
    });
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe(() => {
      dialog.close();
    });
  }

  dataFieldChange(data) {
    this.curMatrixDataEntity.dataFieldAlias = data.data.value;
  }

  selectedDataHandler(data) {
    if (this.index === 0) {
      this.condition1Text = data.name;
      this.condition1Value = data.id;
    } else if (this.index === 1) {
      this.condition2Text = data.name;
      this.condition2Value = data.id;
    } else if (this.index === 2) {
      this.condition3Text = data.name;
      this.condition3Value = data.id;
    }
  }

  getPerformers() {
    this.curMatrixDataEntity.type = 'wf.MatrixParticipantExpression';
    this.curMatrixDataEntity.conditionFieldText1 = this.condition1Text;
    this.curMatrixDataEntity.conditionField1 = this.condition1Text === '' ? '' : this.condition1Value;
    this.curMatrixDataEntity.conditionFieldText2 = this.condition2Text;
    this.curMatrixDataEntity.conditionField2 = this.condition2Text === '' ? '' : this.condition2Value;
    this.curMatrixDataEntity.conditionFieldText3 = this.condition3Text;
    this.curMatrixDataEntity.conditionField3 = this.condition3Text === '' ? '' : this.condition3Value;
    if (this.condition1Multivalue) {
      this.curMatrixDataEntity.multivaluedCondition = 'condition1';
    } else if (this.condition2Multivalue) {
      this.curMatrixDataEntity.multivaluedCondition = 'condition2';
    } else if (this.condition3Multivalue) {
      this.curMatrixDataEntity.multivaluedCondition = 'condition3';
    }else {
      this.curMatrixDataEntity.multivaluedCondition = '';
    }
    return this.curMatrixDataEntity;
  }

  dictHelpPicked = (data: any): Observable<PickedResult> => {
    this.value = null;
    return of({ closeDialog: true });
  }

  /**
   * 打开表达式编辑器
   * @param data 编辑第几个条件字段，值为（condition1，condition2，condition3）
   */
  showExprHelp(data: string) {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        // this.expr.addCommonObject(co);
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.designerUIState.participantContext.length > 0) {
      for (const variable of this.designerUIState.participantContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    if (data === 'condition1') {
      if (this.curMatrixDataEntity.conditionField1) {
        this.expr.addExpressionText(this.curMatrixDataEntity.conditionField1);
      } else {
        this.expr.addExpressionText('');
      }
    } else if (data === 'condition2') {
      if (this.curMatrixDataEntity.conditionField2) {
        this.expr.addExpressionText(this.curMatrixDataEntity.conditionField2);
      } else {
        this.expr.addExpressionText('');
      }
    } else if (data === 'condition3') {
      if (this.curMatrixDataEntity.conditionField3) {
        this.expr.addExpressionText(this.curMatrixDataEntity.conditionField3);
      } else {
        this.expr.addExpressionText('');
      }
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      if (data === 'condition1') {
        this.condition1Text = expressionInfo;
        this.condition1Value = expressionInfo;
      } else if (data === 'condition2') {
        this.condition2Text = expressionInfo;
        this.condition2Value = expressionInfo;
      } else {
        this.condition3Text = expressionInfo;
        this.condition3Value = expressionInfo;
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  condition1Expr(data) {
    this.showExprHelp(data);
  }
  condition1ExprClick() {
    this.condition1ExprAble = !this.condition1ExprAble;
    this.condition1Multivalue = false;
    this.MultivalueOption1 = '';
    this.condition1Text = '';
    this.condition1Value = '';
  }
  condition1MulClick() {
    this.MultivalueOption2 = '';
    this.MultivalueOption3 = '';
    this.condition2Multivalue = false;
    this.condition3Multivalue = false;
    this.condition1Multivalue = !this.condition1Multivalue;
  }
  condition2Expr(data) {
    this.showExprHelp(data);
  }
  condition2ExprClick() {
    this.condition2ExprAble = !this.condition2ExprAble;
    this.condition2Multivalue = false;
    this.MultivalueOption2 = '';
    this.condition2Text = '';
    this.condition2Value = '';
  }
  condition2MulClick() {
    this.MultivalueOption1 = '';
    this.MultivalueOption3 = '';
    this.condition1Multivalue = false;
    this.condition3Multivalue = false;
    this.condition2Multivalue = !this.condition2Multivalue;
  }
  condition3Expr(data) {
    this.showExprHelp(data);
  }
  condition3ExprClick() {
    this.condition3ExprAble = !this.condition3ExprAble;
    this.condition3Multivalue = false;
    this.MultivalueOption3 = '';
    this.condition3Text = '';
    this.condition3Value = '';
  }
  condition3MulClick() {
    this.MultivalueOption1 = '';
    this.MultivalueOption2 = '';
    this.condition1Multivalue = false;
    this.condition2Multivalue = false;
    this.condition3Multivalue = !this.condition3Multivalue;
  }

  onBeforeHelp = (e) => {
    const lookupIns = e.instance;
    if (lookupIns) {
      const getDataFn = lookupIns.http.getData;
      lookupIns.http.getData = this.matDefService.getData;

      lookupIns.dialogClosed.subscribe(() => {
        lookupIns.http.getData = getDataFn;
      });

    }
    return of(true);
  }
}
